import { useEffect, useState } from "react";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import removeClientSideStorage, {
  getButtonText,
  getHeaderText,
} from "../../utils/functions";
import { Delete, Post } from "../../services/apiServices";
import { networkUrls } from "../../services/networkurls";
import { set } from "lodash";
import constants from "../../utils/constants";
interface ReusableModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  type: string;
  category?: string;
  name?: string;
  setIsShowSnackbar?: any;
  setSnackbarInfo?: any;
  id?: number | string | null;
  getCall?: any;
  setIsProceed?: any
  email?: string
  setType?: any
  triggerCall?:any
  
}
export default function ReusableModal({
  open,
  setOpen,
  type,
  category,
  name,
  setIsShowSnackbar,
  setSnackbarInfo,
  id,
  getCall,
  setIsProceed,
  email,
  setType,
  triggerCall
}: ReusableModalProps) {
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(5);
  const navigate = useNavigate();
  const handleLogout = () => {
    removeClientSideStorage();
    navigate("/login");
  };

  const handleDeleteCategory = async () => {
    setLoading(true);
    

    const URL= category==="video" ? networkUrls.deleteVideo : networkUrls.deleteDocument;

    try {
      const response: any = await Delete(
        `${URL}/${id}`,
        true
      );

      if (response?.status === 200) {
        setIsShowSnackbar(true);

        setOpen(false);
        setSnackbarInfo({
          color: "success",
          message: response?.data?.message,
        });
        setTimeout(() => {

          navigate("/documents")
        }, 400)
      } else {
        setOpen(false);
        setIsShowSnackbar(true);
        setSnackbarInfo({
          color: "error",
          message: response?.data?.message,
        });
      }

      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setIsShowSnackbar(true);
      setLoading(false);
      setOpen(false);
      setSnackbarInfo({
        color: "error",
        message: error?.response?.data?.error || "An error occurred",
      });
    }
  };


  useEffect(() => {
    // set interval only once
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);

          // navigate only once when timer hits 0
          if (type === "drive-access-success") {
            navigate(constants.navigationUrls.userDashboard);
          }

          return 0; // stop at 0
        }
        return prev - 1;
      });
    }, 1000);

    // cleanup when unmounting
    return () => clearInterval(interval);
  }, [navigate, type]);


  const grantDriveAccess = async () => {
  setLoading(true);

    try {
      const res = await Post(
        networkUrls.grantDriveAccess,
        { email },
        true
      );
      if (res?.status === 200) {
        setType("drive-access-success")
        setOpen(true)
         setTimer(5); 
        
      }
      else {
        setType("drive-access-failure")
        setOpen(true)
        setTimer(5); 
      }


    } catch (err) {
      console.error("Error granting drive access:", err);
      setType("drive-access-failure")
        setOpen(true)
        setTimer(5); 
    }
    finally {
      setLoading(false);
    }
  }



  const handleConfirmation = () => {
    if (type === "logout") {
      handleLogout();
    } else if (type === "delete") {
      handleDeleteCategory();
    } else if (type === "missing-category") {
      setIsProceed(true);
    }
    else if (type === "drive-access") {
      grantDriveAccess()
    }else if(type==="delete-session"){
      triggerCall()
    }

  };

  const buttonText = getButtonText(type);
  const cancelText = type === "drive-access" ? "No" : "Cancel";
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalDialog variant="outlined" role="alertdialog">
        <DialogTitle>
          {type === "drive-access-success" ? <CheckCircleIcon sx={{ color: "green" }} /> : <WarningRoundedIcon />}
          {type === "drive-access-success" ? "Success" : "Confirmation"}
        </DialogTitle>
        {type !== "drive-access-success" && (

          <IconButton
            sx={{
              position: "absolute",
              top: 0,
              right: 8,
            }}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        )
        }

        <Divider />
        <DialogContent>
          <div
            dangerouslySetInnerHTML={{ __html: getHeaderText(type, category) }}
          />
        </DialogContent>
        {(type !== "drive-access-success" && type !== "drive-access-failure") && (
          <DialogActions>
            <Button
              variant="outlined"
              color="neutral"
              onClick={() => setOpen(false)}
            >
              {cancelText}
            </Button>

            <Button
              variant="solid"
              sx={{ backgroundColor: "#074c90" }}
              onClick={handleConfirmation}
              loading={loading}
            >
              {buttonText}
            </Button>
          </DialogActions>
        )}

        {(type === "drive-access-success" || type === "drive-access-failure") && (
          <span style={{ color: "grey", alignSelf: "center" }}>Logging in {timer}</span>
        )}

      </ModalDialog>
    </Modal>
  );
}
